import { type FastOrderBrand } from '@hooks-api/types/dataModel/fast-order'
import { type FastOrderBrandDto } from '../dtos/fast-order-brand-dto'

export const toFastOrderBrandDtos = (brands: FastOrderBrand[]): FastOrderBrandDto[] =>
  brands
    .map(brand => ({
      projectCode: brand.project_code,
      brandName: brand.brand_name,
      isDefault: brand.is_default,
      displayOrder: brand.display_order ?? Number.MAX_SAFE_INTEGER,
    }))
    .sort((left, right) => left.displayOrder - right.displayOrder)
